import HeroSection from "../../components/UserComponents/heroSection";
import PageHeader from "../../components/common/PageHeader";

export default function TermsOfService() {
  return (
    <div>
      <HeroSection
        title="Terms of Service"
        description="Rules and guidelines for using Toucan."
        showSearchBar={false}
      />

      <div className="max-w-4xl mx-auto px-4 py-10">
        <PageHeader title="Terms of Service" />

        <div className="mt-6 space-y-4 text-md text-gray-600 leading-relaxed">
          <p>
            Toucan operates solely as an online marketplace. Vendors are
            independent third parties.
          </p>

          <p>Users must be at least eighteen (18) years old.</p>

          <p>
            Payments are processed by third-party processors. Toucan does not
            hold user funds.
          </p>

          <p>
            Refunds and cancellations are governed by the Refund &amp;
            Cancellation Policy.
          </p>

          <p>THE PLATFORM IS PROVIDED “AS IS” AND “AS AVAILABLE.”</p>

          <p>Toucan limits liability to the maximum extent permitted by law.</p>

          <p>
            Disputes are resolved by binding arbitration. Governing law:
            Delaware. Class actions are waived.
          </p>
        </div>
      </div>
    </div>
  );
}
